import { useCallback, useContext } from 'react'
import { parseAsString, parseAsStringEnum, useQueryStates } from 'nuqs'
import ModalContext from 'contexts/ModalContext'
import { FlightsClassTypes, RewardFareClass, fareClassToUrlMap } from 'constants/flight'
import { useCharterFilterUrlState } from 'hooks/CharterFlights/useCharterFilterUrlState'
import { getMaldivesBundleCheckOutDate } from '../MaldivesDirectSearchPage/MaldivesDirectUtils'
import MaldivesOnePointPromoModal from './MaldivesOnePointPromoModal'
import { ONE_POINT_PROMO_DATE } from './promoContent'
import useMaldivesOnePointPromoAvailability from './useMaldivesOnePointPromoAvailability'

const promoQueryParsers = {
  bundle: parseAsStringEnum(['5-nights', '12-nights']).withDefault('5-nights'),
  checkIn: parseAsString,
  checkOut: parseAsString,
  offerMode: parseAsString,
}

export default function useMaldivesOnePointPromo(offersSectionId: string, rooms: Array<App.Occupants>) {
  const showModal = useContext(ModalContext)
  const [{ bundle }, setSelection] = useQueryStates(promoQueryParsers)
  const enabled = useMaldivesOnePointPromoAvailability({ rooms, duration: bundle === '12-nights' ? 12 : 5 })
  const { setFareClassUrl, setCabinFilter, setRewardSeatsOnly } = useCharterFilterUrlState()

  const onLearnMore = useCallback(async() => {
    if (!enabled) return
    const trigger = document.activeElement
    await showModal(<MaldivesOnePointPromoModal />)
    if (trigger instanceof HTMLElement && trigger.isConnected) {
      trigger.focus()
    }
  }, [enabled, showModal])

  const onViewOffers = useCallback(async() => {
    if (!enabled) return
    setFareClassUrl(fareClassToUrlMap[RewardFareClass.ECONOMY_REWARDS])
    setCabinFilter(FlightsClassTypes.ECONOMY)
    setRewardSeatsOnly(true)
    await setSelection({
      checkIn: ONE_POINT_PROMO_DATE,
      checkOut: getMaldivesBundleCheckOutDate(ONE_POINT_PROMO_DATE, bundle === '12-nights' ? 12 : 5),
      offerMode: 'hotels',
    })
    window.requestAnimationFrame(() => {
      document.getElementById(offersSectionId)?.scrollIntoView({ block: 'start' })
    })
  }, [enabled, bundle, offersSectionId, setSelection, setFareClassUrl, setCabinFilter, setRewardSeatsOnly])

  return { enabled, onLearnMore, onViewOffers }
}
